var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 8V36C13.3335 37.0609 13.7549 38.0783 14.5051 38.8284C15.2552 39.5786 16.2726 40 17.3335 40H30.6668C31.7277 40 32.7451 39.5786 33.4952 38.8284C34.2454 38.0783 34.6668 37.0609 34.6668 36V8H13.3335ZM32.0001 10.6667V29.3333H16.0002V10.6667H32.0001ZM30.6668 37.3333H17.3335C16.9799 37.3333 16.6407 37.1928 16.3907 36.9428C16.1406 36.6928 16.0002 36.3536 16.0002 36V32H32.0001V36C32.0001 36.3536 31.8597 36.6928 31.6096 36.9428C31.3596 37.1928 31.0204 37.3333 30.6668 37.3333Z",
    fill: "#FEF335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3337 33.3335H22.667V36.0002H25.3337V33.3335Z",
    fill: "#FEF335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsability);
export default __webpack_public_path__ + "static/media/usability.0b6726f60235171e9718a630842e36db.svg";
export { ForwardRef as ReactComponent };